const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
import smoothScroll from 'smooth-scroll';
export default class MenuEvent {
  constructor() {
    this.init();
  }
  init() {
    const menuToggle = document.querySelector('.p_headerToggle');
    const menuWrap = document.querySelector('.p_headerNavWrap');
    const menuWrapInner = document.querySelector('.p_headerNavInner');

    menuToggle.addEventListener('click', (e) => {
      menuWrap.classList.toggle('Act');
      menuToggle.classList.toggle('Act');
      if (menuWrap.classList.contains('Act')) {
        if (window.innerWidth < 786) {
          disableBodyScroll(menuWrapInner);
        }
      } else {
        enableBodyScroll(menuWrapInner);
      }
    });

    let smoothScrollObj = document.getElementsByClassName('js-smoothScroll');
    let option = {
      speed: 10,
      durationMax: 1000,
      durationMin: 800,
      clip: true,
      offset: 0,
      easing: 'easeInOutQuint',
      updateURL: false,
      popstate: false,
    };
    for (let i = 0; i < smoothScrollObj.length; i++) {
      smoothScrollObj[i].addEventListener('click', function (e) {
        let scroll = new smoothScroll('a[href*="#"]', option);
        menuWrap.classList.remove('Act');
        menuToggle.classList.remove('Act');
        enableBodyScroll(menuWrapInner);
      });
    }
  }
}
